module.exports = __webpack_public_path__ + "img/ic_callcenter.36289a69.svg";